<template>
  <div class="lg:mt-0 md:mt-0 z-10">
    <PopupCollaboration
      :isActive="isDetailsActive"
      :selectedCollab="selectedCollab"
      @close="toggleDetails"
    />
    <div class="relative z-index1">
      <img
        src="@/assets/images/line/Frame 1000002302.png"
        alt="lineimg"
        class="m-auto"
      />
      <div class="absolute bg-design-col-t z-index--1 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-col-d absolute z-index--1 mob-hidden">
        <img
          src="../../../assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-col-ecli absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div
        class="w-full mx-auto lg:mb-0 md:mb-0 mb-12 lg:mt-0 md:mt-0"
        id="SolutionDiv2"
      >
        <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
          Engage With Us
        </p>

        <div
          class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 grid-rows-2 md:gap-10 lg:gap-10 gap-4 md:pt-10 lg:pt-10 pt-6"
        >
          <div
            class="md:p-8 lg:p-8 p-4 rounded-2xl"
            v-for="(item, index) in points"
            :key="index"
            :style="{ 'background-color': item.color }"
          >
            <p class="mc-title fsize20-16">{{ item.name }}</p>
            <p
              class="md:pt-4 lg:pt-4 pt-2 mc-subtitle ellipsis-3 fsize18-14-32px cursor-pointer"
              @click="toggleDetails(item)"
            >
              {{ item.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PopupCollaboration from "./PopupCollaboration.vue";
export default {
  components: {
    PopupCollaboration,
  },
  data() {
    return {
      selectedCollab: {},
      isDetailsActive: false,
      points: [
        {
          id: "01",
          color: "#CCEFF2",
          name: " E-learning / Trainings",
          subtitle:
            "We offer Certification programs for Healthcare Practitioners covering techniques of self-care, stress management, effective communication, and holistic care. ",
          route: "e-courses",
        },
        {
          id: "02",
          color: "#eee2ff",
          // name: "Trainings",
          name: "Get Empaneled with us",
          subtitle:
            "List your services on our website for our community of caregivers. Whenever we get a request for your service, our team will connect with you.",
          route: "request-form",
          // subtitle:
          //   "Our Leadership programs aim to help you enhance productivity and efficiency, improve layout design and employee well-being at healthcare institutions.",
        },
        {
          id: "03",
          color: "#CCEFF2",
          name: "Workshops",
          subtitle:
            "Our sessions are a unique platform to co-create caregiving knowledge and effective relationship building, focusing on caregiver needs and well-being of patients.",
          route: "events",
        },
        {
          id: "04",
          color: "#eee2ff",
          name: "Become a Caregiver Coach",
          subtitle:
            "We are looking at leveraging the existing skilled support system to be aligned with the needs of a primary caregiver of people with chronic conditions. The Masterclass program is for Life & Executive Coaches, Yoga Therapists, Counsellors and. Financial Advisors who’d like to get an in-depth understanding of the challenges in the life of a caregiver and provide customized solutions to help them manage their caregiving journey better. You'd need to attend an orientation program to understand the complexity of a Caregiver's role and sign up if you align with the intent of the Masterclass program.",
          route: "coach",
        },
        {
          id: "05",
          color: "#CCEFF2",
          name: "Share your story",
          subtitle:
            "Our conversation series, 'Humanizing Our Healers' is our humble initiative to share the unheard stories and challenges of a healthcare professional's journey. ",
          route: "request-form",
        },
        {
          id: "06",
          color: "#eee2ff",
          name: "Volunteer",
          subtitle:
            "Share your knowledge and expertise with our community of caregivers to help them understand their role better. ",
          route: "request-form",
        },
      ],
    };
  },
  methods: {
    toggleDetails(item) {
      if (item.route === "request-form") {
        if (item.name === "Share your story") {
          this.$router.push({
            name: "request-form",
            params: { pathName: "share-your-story-expertise" },
          });
        } else if (item.name === "Volunteer") {
          this.$router.push({
            name: "request-form",
            params: { pathName: "work-at-cgs-as-volunteer" },
          });
        } else if (item.name === "Get Empaneled with us") {
          this.$router.push({
            name: "request-form",
            params: { pathName: "partner-with-us" },
          });
        }
      } else {
        this.$router.push({ name: item.route });
      }
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .smh-1290px {
    height: 1425px !important;
  }
}
</style>
